import { render, staticRenderFns } from "./InformMassiveUpload.vue?vue&type=template&id=13f8879c&lang=pug"
import script from "./InformMassiveUpload.vue?vue&type=script&lang=js"
export * from "./InformMassiveUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f8879c')) {
      api.createRecord('13f8879c', component.options)
    } else {
      api.reload('13f8879c', component.options)
    }
    module.hot.accept("./InformMassiveUpload.vue?vue&type=template&id=13f8879c&lang=pug", function () {
      api.rerender('13f8879c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InformMassiveUpload.vue"
export default component.exports